import { Rule } from 'antd/lib/form';
import { FormattedMessage } from 'react-intl';

function useDefaultPercentageFieldError(min = 0, max = 100): Rule {
  return {
    type: 'number',
    min,
    max,
    message: <FormattedMessage id="commons.form.errors.percentageField" />,
  };
}

export default useDefaultPercentageFieldError;
